import axios from 'axios';
import { buildConfigWithRecaptchaHeader } from '@/shared/utils/recaptcha';

export const REGISTER_ENDPOINT = '/api/keycloak/register';

export default class RegisterService {
  public processRegistration(token: string, account: any): Promise<any> {
    return axios.post(REGISTER_ENDPOINT, account, buildConfigWithRecaptchaHeader(token));
  }
}
